import {useQuery} from "react-query";
import {Client} from "../../autogenerate/api.generated.clients";

export function useUserParentOrganizations() {
    return useQuery('parent-organizations', () => new Client().organization_GetUserParentOrganizations(),
        {staleTime: 180000, refetchOnMount: false, refetchOnWindowFocus: false, refetchOnReconnect: false})
}